import React from 'react';
import { Table, Modal, Input, Row, Col, Button, Tooltip, Select } from 'antd';
import Pagination from '../../../utils/Pagination';
import { getSuitHeight, createUuid } from '../../../utils/NHCore';
import NHFetch from '../../../utils/NHFetch';
import css from './index.css';
const Search = Input.Search;

class SelectorContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTextMap: {},//下拉框查询的值,用作查询
            filters: {},//多选方式过滤的值
            sorter: {},//排序字段
            searchParams: {},
            treeSearchParams: {},
            dataSource: [],
            selectedRowKeys: [],
            selectedRows: [],
            pagination: Pagination,
            className: createUuid(),
            searchField: undefined,
            searchText: undefined,
        }
    }
    resetState = () => {
        this.setState({
            searchTextMap: {},//下拉框查询的值,用作查询
            filters: {},//多选方式过滤的值
            sorter: {},//排序字段
            searchParams: {},
            treeSearchParams: {},
            dataSource: [],
            selectedRowKeys: [],
            selectedRows: [],
            pagination: Pagination,
            className: createUuid()
        });
    }
    componentWillMount() {
        this.filterTableData();
    }
    componentDidMount() {
        //如果需要自适应高度
        if (!this.props.autoHeightFlag) {
            let height = getSuitHeight(document.getElementsByClassName(this.state.className)[0]);
            this.setState({
                height: height - 110
            });
        }
    }
    filterTableData = () => {
        let pagination = this.state.pagination;
        pagination.page = 1;
        this.setState({ pagination: pagination, searchField: undefined, searchText: undefined, searchParams: {} }, () => {
            this.readTableData();
        });
    }
    readTableData = () => {
        let filters = this.state.filters;//多选过滤的数据
        let sorter = this.state.sorter;//过滤的数据
        let searchTextMap = this.state.searchTextMap;//字段上搜索栏的值
        let searchParams = this.state.searchParams;//传递过来的查询参数
        let sqlParams = this.props.sqlParams;//在sql语句中的参数
        let initParams = this.props.initParams;//初始化参数
        let treeSearchParams = this.props.treeSearchParams;
        if (!treeSearchParams) { treeSearchParams = {}; }
        let params = {
            pagination: this.state.pagination,
            filters: filters,
            sorter: sorter,
            searchTextMap: searchTextMap,
            searchParams: searchParams,
            treeSearchParams: treeSearchParams,
            sqlParams: sqlParams,
            initParams: initParams,
            sign: this.props.sign
        };
        this.setState({
            loading: true
        })
        NHFetch("/proData/querySelectorPage", "post", params).then(res => {
            let dataSource = [];
            let pagination = this.state.pagination;
            if (res && res.data) {
                dataSource = res.data.list,
                    pagination.total = res.data.total;
            }
            this.setState({
                dataSource: dataSource,
                selectedRowKeys: [],
                selectedRows: [],
                pagination: pagination,
                loading: false
            })
        });
    }
    handleTableChange = (pagination, filters, sorter) => {
        this.setState((prevState, props) => ({
            filters: filters,
            sorter: {
                columnKey: sorter.columnKey,
                order: sorter.order
            },
            pagination: {
                total: this.state.pagination.total,
                pageSize: pagination.pageSize,
                page: pagination.current
            }
        }), () => {
            this.readTableData();
        });
    }
    inputChange = (e) => {
        let searchParams = this.state.searchParams;
        let name = e.target.name;
        searchParams[name] = e.target.value;
        this.setState({
            searchParams: searchParams
        });
    }
    buildSearch = (objArr) => objArr.map(obj => {
        let key = obj.key;
        let uuid = createUuid();
        return <div key={uuid} style={{ float: 'left', paddingLeft: 10 }}>
            {obj.name}：<Input name={key} value={this.state.searchParams[key]}
                onChange={this.inputChange} style={{ width: '120px' }} />
        </div>
    });
    zdySearchFieldChange = (value) => {
        this.setState({ searchField: value });
        if (this.state.searchText) {
            let searchParams = {};
            searchParams[value] = this.state.searchText;
            this.setState({ searchParams: searchParams });
        }
    }
    render() {
        let columns = [
            { title: '序号', dataIndex: 'ROW_ID', width: '50px' }, ...this.props.gridColumns];
        let rowSelection = {
            type: this.props.isSingle ? 'radio' : 'checkbox',
            selectedRowKeys: this.props.defaultSelectKeys,
            onSelect: (record, selected, selectedRows) => {
                this.props.selectRowsFunc(record, selected, selectedRows);
            },
            onSelectAll: (selected, selectedRows, changeRows) => {
                this.props.selectAllFunc(selected, selectedRows, changeRows);
            }
        }
        let searchParamsPro = this.props.searchParamsPro ? this.props.searchParamsPro : [];
        let tySearchAllField = 'multiField';
        let tyOptions = [];
        if (searchParamsPro instanceof Array) {
            for (let map of searchParamsPro) {
                tySearchAllField += (',' + map.key);
                tyOptions.push(<Select.Option key={map.key} value={map.key}>{map.name}</Select.Option>);
            }
        } else if (searchParamsPro instanceof Object) {
            tySearchAllField += (',' + searchParamsPro.key);
            tyOptions.push(<Select.Option key={searchParamsPro.key} value={searchParamsPro.key}>{searchParamsPro.name}</Select.Option>);
        }

        // let searchChild = this.buildSearch(searchParamsPro);
        return (<div style={{ margin: '12px 12px 0 12px', padding: '16px 16px 0 16px', height: this.props.commentHeight - 12, overflow: 'hidden', backgroundColor: '#fff' }}>
            {searchParamsPro && searchParamsPro.length > 0 &&
                <div className={css.homeSearchDiv}>
                    <Select style={{ border: 'none' }}
                        value={this.state.searchField ? this.state.searchField : tySearchAllField}
                        onChange={this.zdySearchFieldChange}
                        dropdownMatchSelectWidth={false}
                    >
                        <Select.Option value={tySearchAllField}>全部</Select.Option>
                        {
                            tyOptions
                        }
                    </Select>
                    <Search
                        placeholder="请输入查询条件"
                        onSearch={this.readTableData}
                        value={this.state.searchText}
                        onChange={(e) => {
                            let value = e.target.value;
                            this.setState({
                                searchText: value
                            });
                            let searchParams = {}
                            if (value) {
                                if (this.state.searchField) {
                                    searchParams[this.state.searchField] = value;
                                } else {
                                    searchParams[tySearchAllField] = value;
                                }
                            }
                            this.setState({ searchParams: searchParams });
                        }}
                        style={{ width: 230 }}
                    />
                    <Button type="primary" style={{ margin: '0 20px' }} onClick={this.readTableData}>查询</Button>
                    <Button type="Default" style={{ paddingLeft: 5 }} ghost icon="reload" onClick={() => {
                        this.setState({ searchField: undefined, searchText: undefined, searchParams: {} }, () => {
                            this.filterTableData();
                        })
                    }} >重置</Button>
                </div>
            }

            <Table className={this.state.className} size="small"
                rowKey={record => record[this.props.gridRowKey]}
                rowSelection={rowSelection}
                dataSource={this.state.dataSource}
                columns={columns}
                pagination={this.state.pagination}
                loading={this.state.loading}
                onChange={this.handleTableChange}
                bordered
                scroll={{
                    y: (searchParamsPro != undefined && searchParamsPro.length > 0) ?
                        (this.props.commentHeight - 172) : (this.props.commentHeight - 132), x: 'auto'
                }} />
        </div>);
    }
}

export default SelectorContent;


// WEBPACK FOOTER //
// ./components/common/NHSelector/content.js